import { TEDCustomDateTimeDisplayer } from './TEDCustomDateTimeDisplayer';
import { TEDParseDateTimeMode } from '../FormatterTypes';

class TEDDisplayDateMonth extends TEDCustomDateTimeDisplayer {
  public static getInstance(): TEDDisplayDateMonth {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayDateMonth;
  public mode() {
    return TEDParseDateTimeMode.pdmYM;
  }
}

export { TEDDisplayDateMonth };
